/**
 * Per-app theme configuration.
 * Used by Layout.jsx to set the data-theme attribute on the app root.
 */

export const APP_THEMES = {
  flashcards:   { mode: 'dark',    dataTheme: 'flashcards' },
  matrix:       { mode: 'light',   dataTheme: 'matrix' },
  commandDrill: { mode: 'dark',    dataTheme: 'drill' },
  examSim:      { mode: 'neutral', dataTheme: 'exam' },
  landing:      { mode: 'dark',    dataTheme: 'flashcards' },
};

export const APP_META = [
  {
    id: 'flashcards',
    name: 'Flashcard Engine',
    shortName: 'Flashcards',
    description: 'Spaced repetition for fact retrieval',
    path: '/flashcards',
    icon: '🗂️',
    dailyTime: '15-20 min',
    theme: APP_THEMES.flashcards,
  },
  {
    id: 'matrix',
    name: 'Protocol Comparison Matrix',
    shortName: 'Matrix',
    description: 'Interactive reference & drill for protocol comparisons',
    path: '/matrix',
    icon: '📊',
    dailyTime: 'On-demand',
    theme: APP_THEMES.matrix,
  },
  {
    id: 'commandDrill',
    name: 'Command Syntax Drill',
    shortName: 'Command Drill',
    description: 'CLI command recall under time pressure',
    path: '/drill',
    icon: '⌨️',
    dailyTime: '10-15 min',
    theme: APP_THEMES.commandDrill,
  },
  {
    id: 'examSim',
    name: 'Exam Pressure Simulator',
    shortName: 'Exam Sim',
    description: 'Full exam simulation with review system',
    path: '/exam',
    icon: '🎯',
    dailyTime: '2 hrs weekly',
    theme: APP_THEMES.examSim,
  },
];
